import { computed, readonly, ref } from 'vue';
import HTTP from '@/utils/http';

export function useListIntegrations() {
  const isLoading = ref(false);
  const results = ref([]);
  const meta = ref({});

  // eslint-disable-next-line arrow-body-style
  const hasResults = computed(() => {
    return results.value.length;
  });

  async function fetch() {
    try {
      isLoading.value = true;

      const response = await HTTP({
        url: 'integrations/slack',
      });

      results.value = response.data.data;
      meta.value = response.data.meta;
    } catch (err) {
      // TODO: improve handling

      throw err;
    } finally {
      isLoading.value = false;
    }
  }

  return {
    isLoading: readonly(isLoading),
    results,
    meta,
    hasResults,
    fetch,
  };
}
